import React, { useRef, useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Loader, Dimmer } from 'semantic-ui-react';
import axios from 'axios';
import { validaSoloNumero, validaNumeroTelefono, validaEmail, formatMoneda, validaMonto, formatoMonto, seleccionarCampo } from '../../util/varios';
import moment from 'moment';
import { Mensaje, MensajeSiNo } from '../mensajes';
import CatalogoPersona from '../../catalogos/catalogoPersona';
import { RepeatOneSharp } from '@material-ui/icons';
import CatalogoTipoRetenciones from '../../catalogos/catalogoTipoRetenciones';

export const ModalIncluirFactura = (props) => {

    const fechaSistema = JSON.parse(sessionStorage.getItem('fechasistema'));

    const txtBase = useRef();
    const txtIva = useRef();
    const txtTotal = useRef();
    const txtCodigo = useRef();
    const txtDescrip = useRef();
    const txtFecha = useRef();
    const txtMontoIva = useRef();
    const txtAlicuota = useRef();
    const txtCompromiso = useRef();
    const [activate, setActivate] = useState(false);
    const [mostrar, setMostrar] = useState(false);
    const [Datati, setDatati] = useState([]);
    const [activo, setActivo] = useState(null);
    const [operacion, setOperacion] = useState(0);
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [values, setValues] = useState({
        codigo: 0,
        alicuota: 0.00,
        baseimponible: 0.00,
        descripcion: '',
        fecha: '',
        iva: 0.00,
        montoiva: 0.00,
        total: 0.00,
        totalf: 0.00,
        unidad: 0
    })
    const [datos, setDatos] = useState([]);
    const btnCancela = useRef();
    const btnAcepta = useRef();



    const cancelar = () => {

        if (props.operacion === 2) {
            let data = [];
            let op = 6;
            data.push({
                codigo: txtCodigo.current.value,
                descripcion: txtDescrip.current.value,
                baseimponible: txtBase.current.value.trim().replace(/\./g, '').replace(',', '.'),
                alicuota: txtAlicuota.current.value.trim().replace(/\./g, '').replace(',', '.'),
                total: txtTotal.current.value.trim().replace(/\./g, '').replace(',', '.'),
                fecha: txtFecha.current.value,
                iva: txtIva.current.value,
                totalf: txtCompromiso.current.value.trim().replace(/\./g, '').replace(',', '.'),
                montoiva: txtMontoIva.current.value.trim().replace(/\./g, '').replace(',', '.')
            })
            props.inf(data, op);
            props.onHideCancelar();
            blanquear();
        } else {
            props.onHideCancelar();
            blanquear();
        }

    }

    const blanquear = () => {
        setActivate(false);
        txtCodigo.current.value = '';
        txtDescrip.current.value = '';
        txtBase.current.value = '';
        txtIva.current.value = '';
        txtMontoIva.current.value = '';
        txtCompromiso.current.value = '';
        txtAlicuota.current.value = '';
        txtTotal.current.value = '';
        setDatati([]);
        setActivo(null);
    };

    const handleInputNumChange = (event) => {
        event.preventDefault();
        validaSoloNumero(event);

        if (event.which === 13 || typeof (event.which) === 'undefined') {

            setDatos({ ...datos, [event.target.name]: event.target.value });

        } else if (event.which === 46) {
            return false;
        } else if (event.which >= 48 && event.which <= 57) {
            return true;
        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
            return true;
        } else return false;
    };

    const onCalculo = (datos) => {

        let data = [];
        let totaliv = 0.00;
        let baseimpo = 0.00;
        let miv = 0.00;
        let ali = 0.00;
        let fecha = txtFecha.current.value;
        let iva = 0.00;
        let totalfact = 0.00;

        if (datos.unidad !== 3) {

            miv = txtMontoIva.current.value === '' ? '0.00' : txtMontoIva.current.value.trim().replace(/\./g, '').replace(',', '.');
            ali = txtAlicuota.current.value === '' ? '0.00' : txtAlicuota.current.value.trim().replace(/\./g, '').replace(',', '.');
            iva = txtIva.current.value === '' ? '0.00' : txtIva.current.value.trim().replace(/\./g, '').replace(',', '.');
            totalfact = txtBase.current.value === '' ? '0.00' : txtBase.current.value.trim().replace(/\./g, '').replace(',', '.');

        } else {

            totalfact = props.data[0].base;
            baseimpo = props.data[0].base;
            iva = props.data[0].iva;
            miv = props.data[0].montoiva;
            totaliv = txtTotal.current.value.trim().replace(/\./g, '').replace(',', '.');

        }

        if (datos.idtiporetencion === '1') {
            totaliv = miv * ali / 100;
            baseimpo = miv;
            txtTotal.current.value = formatMoneda(totaliv.toString().replace(',', '').replace('.', ','), ',', '.', 2);
        } else if (datos.tipo === 1) {
            totaliv = totalfact * ali / 100;
            baseimpo = totalfact;
            txtTotal.current.value = formatMoneda(totaliv.toString().replace(',', '').replace('.', ','), ',', '.', 2);
        } else if (datos.unidad === 4) {
            totaliv = totalfact / ali;
            baseimpo = totalfact;
            txtTotal.current.value = formatMoneda(totaliv.toString().replace(',', '').replace('.', ','), ',', '.', 2);
        }

        data.push({
            codigo: datos.idtiporetencion,
            descripcion: datos.descripcion,
            baseimponible: baseimpo,
            alicuota: ali,
            total: totaliv,
            fecha: fecha,
            iva: iva,
            totalf: totalfact,
            montoiva: props.data[0].montoiva,
            unidad: datos.unidad
        });
        setDatos(data);

    }

    const handleInputMontoChange = (event) => {
        validaMonto(event);
        if (event.which === 13 || typeof (event.which) === 'undefined') {

            if (event.target.value === '' || parseFloat(event.target.value.trim().replace(".", "").replace(",", ".")) === 0.00) {
                event.target.value = '0,00'
            }
            event.target.value = (formatoMonto(event.target.value));
            let char1 = event.target.value.substring(0, 1);
            let char2 = event.target.value.substring(1, 2);
            if (char1 === '0' && char2 !== ',') {
                event.target.value = event.target.value.substring(1, event.target.value.legth);
            }
            if (event.which === 13) {
                if (event.target.id === 'alicuota') {
                    onCalculo(Datati);
                    txtAlicuota.current.focus();
                } else if (event.target.id === 'total') {
                    onCalculo(Datati);
                    setOperacion(1);
                    btnAcepta.current.focus();
                }
            }
        } else if (event.which === 46) {
            return false;
        } else if (event.which >= 48 && event.which <= 57) {
            return true;
        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
            return true;
        } else return false;
    };

    const cerrarModal = () => {
        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
        props.onHideCancelar();
        blanquear();
    }

    const datosFactura = () => {
        props.onHideDatos(datos);
        setActivo(0);
    };

    const onCatalogoCerrar = () => {
        setMostrar(false);
    }

    const onCatalogoTipoRentas = () => {
        setMostrar(true);
    }

    const onCatalogoTipoRentasData = (infor) => {
        setMostrar(false);

        let idv;
        for (let i = 0; i < values.length; i++) {
            idv = values[i].codigo;
        }
        if (infor.idtiporetencion === idv) {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Este Tipo de Retención ya fue Cargada', icono: 'error' });
        } else {
            txtCodigo.current.value = infor.idtiporetencion;
            txtDescrip.current.value = infor.descripcion;
            setDatati(infor);
            if (infor.idtiporetencion === '1') {
                let m = 75;
                txtAlicuota.current.value = formatMoneda(m.toString().replace(',', '').replace('.', ','), ',', '.', 2);
                onCalculo(infor);
            } else if (infor.tipo === 1) {
                txtAlicuota.current.value = formatMoneda(infor.deducible.toString().replace(',', '').replace('.', ','), ',', '.', 2);
                onCalculo(infor);
            } else if (parseInt(infor.unidad) === 3) {
                setActivo(1);
                setOperacion(4);
            } else if (parseInt(infor.unidad) === 4) {
                txtAlicuota.current.value = formatMoneda(infor.otro.toString().replace(',', '').replace('.', ','), ',', '.', 2);
                onCalculo(infor);
            }
        }

    }

    return (
        <Modal
            {...props}
            size="xl"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
            backdrop="static"
            keyboard={false}
            onShow={() => {

                if (props.operacion === 1) {
                    txtCodigo.current.focus();
                    setValues(props.idc);
                    txtBase.current.value = formatMoneda(props.data[0].base.toString().replace(',', '').replace('.', ','), ',', '.', 2);
                    txtIva.current.value = formatMoneda(props.data[0].iva.toString().replace(',', '').replace('.', ','), ',', '.', 2);
                    txtMontoIva.current.value = formatMoneda(props.data[0].montoiva.toString().replace(',', '').replace('.', ','), ',', '.', 2);
                    txtCompromiso.current.value = formatMoneda(props.data[0].totalc.toString().replace(',', '').replace('.', ','), ',', '.', 2);
                } else if (props.operacion === 2) {

                    if (props.datos[0].codigo === '3') {
                        setActivo(1);
                    } else {
                        setActivo(0);
                    }

                    let montototal = parseFloat(props.datos[0].totalf) + parseFloat(props.datos[0].montoiva);
                    txtCodigo.current.value = props.datos[0].codigo;
                    txtDescrip.current.value = props.datos[0].descripcion;
                    txtBase.current.value = formatMoneda(props.datos[0].totalf.toString().replace(',', '').replace('.', ','), ',', '.', 2);
                    txtIva.current.value = formatMoneda(props.datos[0].iva.toString().replace(',', '').replace('.', ','), ',', '.', 2);
                    txtMontoIva.current.value = formatMoneda(props.datos[0].montoiva.toString().replace(',', '').replace('.', ','), ',', '.', 2);
                    txtCompromiso.current.value = formatMoneda(montototal.toString().replace(',', '').replace('.', ','), ',', '.', 2);
                    txtAlicuota.current.value = formatMoneda(props.datos[0].alicuota.toString().replace(',', '').replace('.', ','), ',', '.', 2);
                    txtTotal.current.value = formatMoneda(props.datos[0].total.toString().replace(',', '').replace('.', ','), ',', '.', 2);

                } else {
                    txtCodigo.current.value = '';
                    txtDescrip.current.value = '';
                    txtBase.current.value = '';
                    txtIva.current.value = '';
                    txtMontoIva.current.value = '';
                    txtCompromiso.current.value = '';
                    txtAlicuota.current.value = '';
                    txtTotal.current.value = '';
                }

            }}

        >
            <Modal.Header className='azulGradiant header-modal'>
                <div className='fw-bold text-light'><h3>Incluir Retenciones</h3></div>
                <button className="bg-transparent" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={cancelar}>
                    <i className="far fa-window-close"></i>
                </button>

            </Modal.Header>
            <Modal.Body>

                <CatalogoTipoRetenciones
                    show={mostrar}
                    onHideCancelar={onCatalogoCerrar}
                    onHideAceptaCatalogo={onCatalogoTipoRentasData}
                />

                <Dimmer active={activate} inverted>
                    <Loader inverted>cargando...</Loader>
                </Dimmer>
                <div className='container-fluid  rounded row mx-auto'>
                    <div className='col-md-12 mb-2 mx-auto px-0'>
                        <fieldset className=' row col-sm-12 mx-auto border-azul rounded'>
                            <legend className="float-none w-auto fw-bold" style={{ fontSize: '15px' }}>Datos de la Retención</legend>

                            <div className='col-md-12 row m-0'>


                                <div className="input-group input-group-sm mb-2 col-md-2">
                                    <label className="input-group-text" id="inputGroup-sizing-sm">Código:</label>
                                    <input type="text" ref={txtCodigo} name="codigo" id='codigo' className="form-control" onKeyUp={handleInputNumChange} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                                    <button type="button" onClick={() => onCatalogoTipoRentas()} className="btn btn-sm btn-primary"><i className="fas fa-search"></i></button>
                                </div>

                                <div className="input-group input-group-sm mb-2 col-md-7">
                                    <label className="input-group-text" id="inputGroup-sizing-sm">Descripción:</label>
                                    <input type="text" ref={txtDescrip} name="otros" id='otros' className="form-control text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                                </div>


                                <div className="input-group input-group-sm mb-2 col-md-3">
                                    <label className="input-group-text" id="inputGroup-sizing-sm">Fecha de Retención:</label>
                                    <input type="date" ref={txtFecha} name="ajustes" id='ajustes' className="form-control text-right" defaultValue={moment(fechaSistema).format('YYYY-MM-DD')} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                                </div>


                            </div>

                            <fieldset className='row col-sm-12 mx-auto border-azul rounded px-1'>

                                {
                                    activo !== 1 ? <div className='row m-0'>
                                        <div className='col-md-3'>
                                            <div className="input-group input-group-sm mb-2">
                                                <label className="input-group-text" id="inputGroup-sizing-sm">Base Imponible:</label>
                                                <input type="text" ref={txtBase} name="base" className="form-control text-right" disabled placeholder='0,00' aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                                            </div>
                                        </div>

                                        <div className='col-md-2'>
                                            <div className="input-group input-group-sm mb-2 col-md-9 mx-auto">
                                                <label className="input-group-text" id="inputGroup-sizing-sm">% IVA:</label>
                                                <input type="text" ref={txtIva} disabled name="iva" id='iva' className="form-control text-center" onKeyUp={handleInputMontoChange} onBlur={handleInputMontoChange} placeholder='0,00' aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                                            </div>
                                        </div>

                                        <div className='col-md-2'>
                                            <div className="input-group input-group-sm mb-2">
                                                <label className="input-group-text" id="inputGroup-sizing-sm">Monto IVA:</label>
                                                <input type="text" ref={txtMontoIva} name="totaliva" disabled className="form-control text-right" placeholder='0,00' aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                                            </div>
                                        </div>

                                        <div className='col-md-3'>
                                            <div className="input-group input-group-sm mb-2">
                                                <label className="input-group-text" id="inputGroup-sizing-sm">Total Factura:</label>
                                                <input type="text" ref={txtCompromiso} disabled name="exento" id='exento' className="form-control text-right" onKeyUp={handleInputMontoChange} onBlur={handleInputMontoChange} placeholder='0,00' aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                                            </div>
                                        </div>

                                        <div className='col-md-2'>
                                            <div className="input-group input-group-sm mb-2">
                                                <label className="input-group-text" id="inputGroup-sizing-sm">Alicuota:</label>
                                                <input type="text" ref={txtAlicuota} name="alicuota" id='alicuota' className="form-control text-right" onKeyUp={handleInputMontoChange} onBlur={handleInputMontoChange} placeholder='0,00' aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                                            </div>
                                        </div>

                                        <div className='col-md-3 ml-auto'>
                                            <div className="input-group input-group-sm mb-2">
                                                <label className="input-group-text" id="inputGroup-sizing-sm">Total Retención:</label>
                                                <input type="text" ref={txtTotal} disabled={activo !== 1 ? true : false} name="exento" id='exento' className="form-control text-right" onKeyUp={handleInputMontoChange} onBlur={handleInputMontoChange} placeholder='0,00' aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                                            </div>
                                        </div>
                                    </div> :
                                        <div className='row m-0'>
                                            <input type="hidden" ref={txtBase} name="base" />
                                            <input type="hidden" ref={txtIva} name="iva" />
                                            <input type="hidden" ref={txtMontoIva} name="totaliva" />
                                            <input type="hidden" ref={txtCompromiso} name="exento" />
                                            <input type="hidden" ref={txtAlicuota} name="alicuota" />
                                            <div className='col-md-3 ml-auto'>
                                                <div className="input-group input-group-sm mb-2">
                                                    <label className="input-group-text" id="inputGroup-sizing-sm">Total Retención:</label>
                                                    <input type="text" ref={txtTotal} disabled={activo !== 1 ? true : false} name="total" id='total' onBlur={handleInputMontoChange} onKeyUp={handleInputMontoChange} className="form-control text-right" placeholder='0,00' aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                                                </div>
                                            </div>
                                        </div>
                                }

                            </fieldset>

                        </fieldset>
                    </div>


                </div>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" ref={btnAcepta} onClick={datosFactura} disabled={operacion === 4 ? true : false} style={{ margin: '1px' }} className=" btn btn-success btn-sm rounded-pill"><i className="far fa-check-circle"></i> Aceptar</button>
                <button type="button" ref={btnCancela} onClick={cancelar} style={{ margin: '1px' }} className=" btn btn-sm btn-danger rounded-pill"><i className="fas fa-window-close"></i> Cancelar</button>
            </Modal.Footer>


            <Mensaje mensaje={mensaje}
                onHide={() => {
                    mensaje.titulo === 'Exito.' ?
                        cerrarModal() :
                        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
                }
                } />
            <MensajeSiNo mensaje={mensajesino}
                onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} />
        </Modal>

    );
}


// WEBPACK FOOTER //
// ./src/components/compra/modalIncluirFactura.js